import React, { useMemo, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBackSharp } from "react-icons/io5";
import { getAuthToken, getClientType } from "../services/clientConfig";
/**
 * Persistent Analysis iframe component.
 * Always mounted in the DOM to avoid reload delays.
 * Reports load status via onLoad callback.
 */
function AnalysisIframe({ visible, onIframeLoad }) {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);

  const handleLoad = useCallback(() => {
    setLoaded(true);
    if (onIframeLoad) onIframeLoad();
  }, [onIframeLoad]);

  const iframeSrc = useMemo(() => {
    const baseUrl = process.env.REACT_APP_ANALYSIS_LINK;
    const authToken = getAuthToken();
    const clientType = getClientType();

    const params = new URLSearchParams();
    if (authToken) {
      params.set("auth_token", authToken);
    }

    if (clientType && clientType !== 'default') {
      params.set("client_type", clientType);
    }

    return `${baseUrl}?${params.toString()}`;
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        zIndex: visible ? 99999 : -1,
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
      }}
    >
      {visible && (
        <button
          title="Torna alla pagina precedente"
          onClick={() => navigate(-1)}
          style={{
            position: "fixed",
            left: "20px",
            top: "97px",
            zIndex: 100000,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "3px 14px",
            backgroundColor: "#353A0A",
            color: "white",
            border: "1px solid #a1e430",
            borderRadius: "10px",
            cursor: "pointer",
            fontSize: "20px",
            fontWeight: 500,
            backdropFilter: "blur(8px)",
            transition: "background-color 0.2s, transform 0.2s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#a1e430";
            e.currentTarget.style.transform = "scale(1.1)";
              e.currentTarget.style.color = "white";
               e.currentTarget.style.borderColor = "#a1e430";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#353A0A";
            e.currentTarget.style.color = "white";
            e.currentTarget.style.borderColor = "#a1e430";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <IoArrowBackSharp />
        </button>
      )}
      <iframe
        src={iframeSrc}
        onLoad={handleLoad}
        style={{ width: "100%", height: "100%", border: "none" }}
        title="Analysis"
      />
    </div>
  );
}

export default AnalysisIframe;
